import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { formatDurationWithBreakParts } from "../utils/formatDurationWithBreakParts";

interface DurationWithBreakDisplayProps {
  totalDurationInHours: number;
  breakDurationInMinutes: number;
  requiresBreak: boolean;
  showBreakInfo?: boolean;
  minutesElapsed?: number;
}

/**
 * Displays shift duration with the main duration in normal text
 * and break information in smaller, grey text on the same row
 */
export function DurationWithBreakDisplay(props: DurationWithBreakDisplayProps) {
  const {
    totalDurationInHours,
    breakDurationInMinutes,
    requiresBreak,
    showBreakInfo = true,
    minutesElapsed,
  } = props;

  const { duration, breakInfo } = formatDurationWithBreakParts({
    totalDurationInHours,
    breakDurationInMinutes,
    requiresBreak,
    minutesElapsed,
  });

  return (
    <Stack direction="row" spacing={2} alignItems="baseline">
      <Text
        variant={showBreakInfo ? "body1" : "body2"}
        color={(theme) =>
          showBreakInfo ? theme.palette.text.primary : theme.palette.text.tertiary
        }
      >
        {duration}
      </Text>
      {showBreakInfo && (
        <Text variant="body2" color={(theme) => theme.palette.text.tertiary}>
          {breakInfo}
        </Text>
      )}
    </Stack>
  );
}
